import React, { useState, useEffect } from 'react';
import Layouts from '../components/Layouts';
import ClientDetailForm from './ClientDetailForm';
import QuoteGenerationForm from './QuoteGenerationForm';
import apiRequest from '../hooks/ApiRequest';

const GenerateQuote = () => {
  const [customerData, setCustomerData] = useState(null);
  const LoginInsurerId = JSON.parse(localStorage.getItem('loggedInUserID'))

  useEffect(() => {
    const fetchCustomerData = async () => {
      try {
        const userEmail = JSON.parse(localStorage.getItem('user'))?.email;
        if (!userEmail) return;

        const res = await apiRequest(process.env.REACT_APP_BASE_CUST + `/Customers/GetCustDetailsByUserID/${LoginInsurerId}`, 'GET');
        const customers = res.data || [];

        //const matchedCustomer = customers.find(cust => cust.emailAddress === userEmail);

setCustomerData(customers);

        // if (matchedCustomer) {
        //   setCustomerData(customers);
        // } else {
        //   setCustomerData(null);
        // }
      } catch (err) {
        console.error('Error fetching customers:', err);
      }
    };

    fetchCustomerData();
  }, []);

  return (
    <Layouts title="Insurance Quotes" classname="dashboard">
      <div className="dash-bg-white">
        <h3 style={{ color: '#0C1362', fontWeight: '600', fontSize: '20px' }}>
          Client Details
        </h3>
        <ClientDetailForm customerData={customerData} />

        <div style={{ marginTop: '40px' }}>
          <h3 style={{ color: '#0C1362', fontWeight: '600', fontSize: '20px' }}>
            Generate Insurance Quote
          </h3>
          <QuoteGenerationForm customerData={customerData} />
        </div>
      </div>
    </Layouts>
  );
};

export default GenerateQuote;
